export const COMPANY_DATA = {
  mailID: "info@quantarock.in",
  phoneNumber: "+91-9755010858",
  companyName: "QuantaRock Systems Private Limited",
  ceoName: "Vipendra Mehra",
  address:
    "444, Shyam Nagar(main), Sukhliya Indore, Madhya Pradesh, India - 452010",
  linkedInURL: "https://www.linkedin.com/company/quantarock-systems",
  facebookURL: "https://www.facebook.com/profile.php?id=61550422080802",
  mailURL: "mailto:info@quantarock.in",
  twitterURL: "https://x.com/QuantaRock?s=20",
  instaURL: "https://www.instagram.com/quantarock_systems_india/",
  youtubeURL: "https://www.youtube.com/@Quantarock",
  careerFormLink: "https://form.jotform.com/242311429569459",
  webDomain: "https://quantarock.in/",
};

export const TEAM_DATA = [
  {
    name: "Vipendra Mehra",
    role: "CEO",
    image: "ceo.webp",
    linkedInURL: "https://www.linkedin.com/in/vipendra-mehra-719947116/",
    mailURL: "mailto:vipendra@quantarock.in",
    twitterURL: "https://twitter.com/VipendramehraVM",
  },
  {
    name: "Amrit Singh",
    role: "CMO",
    image: "cmo.webp",
  },
  {
    name: "Advika Kumar",
    role: "CTO",
    image: "cto.webp",
  },
];

export const ABOUTUS_DATA = [
  {
    title: "Our Mission",
    description:
      "At QuantaRock Systems, our mission is to make technology accessible to everyone at an affordable price. We believe that technology is most valuable when it's in the hands of many, and we are dedicated to providing a platform where all can benefit from the latest advancements in IT.",
    image: "Mission.webp",
  },
  {
    title: "Our Vision",
    description:
      "We envision a world where technology is not a luxury but a necessity for all. With a collaborative approach, we strive to create a single platform that encompasses all technologies. Our vision is to bridge the gap and make cutting-edge IT solutions accessible to every individual and business.",
    image: "vision.webp",
  },
  {
    title: "Our Values",
    description:
      "Integrity, innovation, and excellence in everything we do. We believe in delivering top-tier solutions with a focus on collaboration, transparency, and respect for our clients, partners, and team. Our core values inspire us to continuously innovate, uphold the highest standards, and foster a culture of growth and positivity.",
    image: "Values.webp",
  },
];

export const HOME_SERVICES_DATA = [
  {
    title: "IT Hardware",
    description:
      "Enterprise servers, storage, and networking equipment, sourced and configured for your infrastructure.",
    image: "1.png",
  },
  {
    title: "Datacenter and Hosting Solutions",
    description:
      "Colocation, dedicated servers, and managed hosting across our data center network.",
    image: "2.png",
  },
  {
    title: "Software and licensing",
    description:
      "Competitive pricing on enterprise software and licensing, backed by expert guidance.",
    image: "3.png",
  },
  {
    title: "Compliance and certification",
    description:
      "Compliance readiness and certification support, including ISO 27001 and ISO 9001.",
    image: "4.png",
  },
  {
    title: "IT Leasing and maintenance",
    description:
      "Flexible OPEX-based hardware leasing with ongoing maintenance and support.",
    image: "5.png",
  },
  {
    title: "Tech Consultation and Project Management",
    description:
      "Technical consultation and data center project management, from planning through deployment.",
    image: "6.png",
  },
];

export const TOP_SELLING_SERVER_DATA = [
  {
    title: "Dell R630",
    price: "20000",
    currency: "OTC /- INR + GST",
    description: [
      "Up to 1 Year Warranty",
      "100% Tested and Verified",
      "Dell Perc H730 Raid Controller",
      "Free consultation",
      "Configuration support",
    ],
  },
  {
    title: "R730XD",
    price: "29999",
    currency: "OTC /- INR + GST",
    description: [
      "Up to 1 Year Warranty",
      "100% Tested and Verified",
      "Dell Perc H730 Raid Controller",
      "Free consultation",
      "Configuration support",
    ],
  },
  {
    title: "DL360 Gen 9 4LFF",
    price: "19999",
    currency: "OTC /- INR + GST",
    description: [
      "Up to 1 Year Warranty",
      "100% Tested and Verified",
      "HPE P440/P441 Raid Controller",
      "Free consultation",
      "Configuration support",
    ],
  },
];

export const CERTIFICATES_DATA = [
  {
    id: "iso27001",
    title: "ISO 27001:2022",
    description:
      "Information Security Management Systems certification ensuring robust security controls and risk management practices.",
    issueDate: "10/09/2025",
    expiryDate: "09/09/2028",
    imgSrc: "Registration.webp", // save a preview image in assets/Services/certificates/
    file: "/files/QUANTAROCK SYSTEMS PRIVATE LIMITED 27001 FINAL ICV.pdf", // adjust public path
  },
  {
    id: "iso9001",
    title: "ISO 9001:2015",
    description:
      "Quality Management System certification demonstrating our commitment to consistent quality and customer satisfaction.",
    issueDate: "16/09/2025",
    expiryDate: "15/09/2028",
    imgSrc: "ISO.webp", // save preview image in assets/Services/certificates/
    file: "/files/QUANTAROCK SYSTEMS PRIVATE LIMITED QMS.pdf", // adjust public path
  },
];

export const TEAM_CERTIFICATES_DATA = [
  {
    id: "anz_cyber",
    title: "Cyber@ANZ Program",
    description:
      "Certificate of Completion for practical task modules in Social Engineering Investigation and Digital Investigation.",
    issueDate: "20/06/2020",
    expiryDate: "-", // No expiry
    imgSrc: "anz_certificate.webp", // save preview image in assets/Services/certificates/
    file: "/files/anz_cyber_program_completion_certificate.pdf",
  },
  {
    id: "redis_ru330",
    title: "Redis RU330: Redis Security",
    description:
      "Redis University certification for successfully completing Redis Security (RU330).",
    issueDate: "23/09/2022",
    expiryDate: "-", // No expiry
    imgSrc: "redis_certificate.webp", // save preview image in assets/Services/certificates/
    file: "/files/Vipendra - redislabs RU330 Certificate - Redis University.pdf",
  },
  {
    id: "icsi_cnss",
    title: "ICSI CNSS Certified Network Security Specialist",
    description:
      "Certified Network Security Specialist by ICSI, demonstrating expertise in network and security fundamentals.",
    issueDate: "03/06/2020",
    expiryDate: "-", // No expiry
    imgSrc: "icsi_certificate.webp", // save preview image in assets/Services/certificates/
    file: "/files/icsi_network_security_specialist_certificate.pdf",
  },
  {
    id: "skillfront_iso",
    title: "SkillFront ISO/IEC 27001 Associate",
    description:
      "Accredited Professional Certification: ISO/IEC 27001 Information Security Associate from SkillFront.",
    issueDate: "08/03/2023",
    expiryDate: "-", // No expiry
    imgSrc: "skillfront_certificate.webp", // save preview image in assets/Services/certificates/
    file: "/files/skillfront_iso27001_associate_certificate.pdf",
  },
];

export const ALL_DETAIL_ROUTES_INFO = [
  COMPANY_DATA,
  ...TEAM_DATA,
  ...ABOUTUS_DATA,
  HOME_SERVICES_DATA,
  TOP_SELLING_SERVER_DATA,
  CERTIFICATES_DATA,
  TEAM_CERTIFICATES_DATA,
];
